import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DirectionService } from '../../../direction.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-paper-tooltip-content',
    templateUrl: './paper-tooltip.component.html',
    styleUrls: ['./paper-tooltip.component.css'],
})

export class PaperTooltipContentComponent implements OnInit, OnDestroy {
    isRTL: boolean = true;
    isDarkMode: boolean = false;
    private directionSubscription: Subscription;
    expressPapers: Array<any>;

    @Input() header: string;
    @Input() text: string;

    @Input() property: string;
    @Input() printingService: string;
    @Input() inputBins: any;
    @Input() printServicePapers: any;
    @Input() realBranch: any;

    constructor(
        private directionService: DirectionService,
    ) { }

    ngOnInit() {
        this.directionSubscription = this.directionService.direction$.subscribe(direction => {
            this.isRTL = direction === 'rtl';
        });

        // console.log("this.realBranch!!!", this.realBranch);

        this.directionService.isDarkMode$.subscribe(isDarkMode => {
            this.isDarkMode = isDarkMode;
        });

        this.expressPapers = [];
        for (let paper of this.printServicePapers) {
            let newPaper = {
                paperWidth: 0,
                paperHeight: 0,
                paperWeight: 0,
                serialName: ''
            }
            if (paper.serial_name === 'A4') {
                newPaper.paperWidth = 21;
                newPaper.paperHeight = 29.7;
                newPaper.paperWeight = 100;
            } else if (paper.serial_name === 'A3') {
                newPaper.paperWidth = 29.7;
                newPaper.paperHeight = 42;
                newPaper.paperWeight = 100;
            } else if (paper.serial_name === 'A4160') {
                newPaper.paperWidth = 21;
                newPaper.paperHeight = 29.7;
                newPaper.paperWeight = 160;
            } else if (paper.serial_name === 'A3160') {
                newPaper.paperWidth = 29.7;
                newPaper.paperHeight = 42;
                newPaper.paperWeight = 160;
            } else if (paper.serial_name === 'A4Recycled') {
                newPaper.paperWidth = 21;
                newPaper.paperHeight = 29.7;
                newPaper.paperWeight = 120;
            } else if (paper.serial_name === 'SM') {
                newPaper.paperWidth = 15.24;
                newPaper.paperHeight = 10.16;
                newPaper.paperWeight = 260;
            } else if (paper.serial_name === 'MD') {
                newPaper.paperWidth = 17.78;
                newPaper.paperHeight = 12.7;
                newPaper.paperWeight = 260;
            } else if (paper.serial_name === 'LG') {
                newPaper.paperWidth = 20.32;
                newPaper.paperHeight = 15.24;
                newPaper.paperWeight = 260;
            }
            this.expressPapers.push(newPaper);
        }
    }

    // PRICES
    getPaperPriceExpress(paperType: string, xFactor: string, sides: string, color: string): number {
        let paper;
        if (xFactor === 'first') {
            paper = this.realBranch.express?.pricing?.prices_x?.[paperType.toLowerCase()];
        } else if (xFactor === 'more') {
            paper = this.realBranch.express?.pricing?.prices?.[paperType.toLowerCase()];
        }
        let category;
        if (sides === 'single')
            category = paper.single;
        else if (sides === 'double') {
            category = paper.double;
        }
        let price = 0;
        if (color === 'color')
            price = category.color;
        else if (color === 'bw') {
            price = category.bw;
        }
        return price;
    }

    isExtraPriceExpress(paperType: string, sides: string, color: string): boolean {
        let firstPrice = this.getPaperPriceExpress(paperType, 'first', sides, color);
        let morePrice = this.getPaperPriceExpress(paperType, 'more', sides, color);
        return firstPrice !== morePrice;
    }

    isDubbleSidedPaper(paperType: any): boolean {
        if (this.printingService === 'express' && this.realBranch.express?.isPicsPrinter) {
            return false;
        }
        if (paperType.disable_double_anyway) {
            return false;
        }
        return true;
    }

    ngOnDestroy() {
        if (this.directionSubscription) {
            this.directionSubscription.unsubscribe();
        }
    }

    roundDownDecimal(num: number): number {
        return Math.ceil(num * 10) / 10;
    }
}